// extracted by mini-css-extract-plugin
module.exports = {"qualitySection":"style_qualitySection__3zG0G","linkGroup":"style_linkGroup__8Znuw","qualityLinkBlock":"style_qualityLinkBlock__291C5"};